import React, { useState, useEffect } from 'react'
import Image from '../atoms/Image'
import Headline from '../atoms/Headline'
import SbEditable from 'storyblok-react'

import Modal from 'react-modal'
import { Helmet } from 'react-helmet'
import Video from '../atoms/Video'

const VideoBlock = ({ block, className, name }) => {
  const [modalIsOpen, setIsOpen] = useState(false)

  const openModal = () => {
    //e.preventDefault()
    setIsOpen(true)
  }
  const closeModal = () => {
    //e.preventDefault()
    setIsOpen(false)
  }
  useEffect(() => {
    return () => {
      setIsOpen(false)
    }
  }, [])
  return (
    <SbEditable content={block}>
      <section className={`video-block ${className}`}>
        <div className="video-block-container">
          <div className="video-block-wrapper">
            <div className="row">
              <div className="video-block-video">
                <div
                  className="video-block-video-link"
                  onClick={() => {
                    openModal()
                  }}
                >
                  <div className="video-block-video-teaser">
                    <Image image={block.image} alt={block.alt} />
                  </div>
                </div>
              </div>
              <div className="video-block-text">
                <div className="video-block-text-inner">
                  {/* <div className="h2-kicker">{@root.name}</div> TODO: root.name hier verfügbar machen */}
                  <Headline
                    kicker={name}
                    headline={block.headline}
                    subheadline={block.subheadline}
                    headline_level={block.headline_level}
                  />
                  <p>{block.text}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => closeModal()}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,.5)',
            zIndex: '1060',
            cursor: 'pointer',
          },
          content: {
            background: 'transparent',
            border: 'none',
            inset: '0',
            padding: '1.5rem',
            pointerEvents: 'none',
          },
        }}
        shouldCloseOnOverlayClick={true}
      >
        <Helmet bodyAttributes={{ class: 'overflow-hidden' }} />
        <div className="modal-inner">
          <div className="modal-header">
            <h4 className="modal-title" id="spa-modal-label">
              {block.headline}
            </h4>
            <input
              className="btn btn-close"
              type="button"
              value=""
              onClick={(e) => closeModal(e)}
            />
          </div>
          <div className="modal-body">
            <div className="figmedia">
              <Video video={block.video_url + '?badge=0&autoplay=1&html5=1'} />
            </div>
          </div>
        </div>
      </Modal>
    </SbEditable>
  )
}

export default VideoBlock
